import {takeEvery, takeLatest, put, call, all, fork} from "redux-saga/effects"

import {
  INVOICE_DETAIL,
  INVOICE_SELECT,
  INVOICE_UPDATE,
} from "./actionTypes"

import {
  invoiceDetailSuccess,
  invoiceDetailError,
  invoiceSelectSuccess,
  invoiceSelectError,
  invoiceUpdateSuccess,
  invoiceUpdateError,
} from "./actions"

import {
  apiGetInvoiceDetail,
  apiGetInvoiceSelect,
  apiPostInvoiceUpdate,
} from "../../api/calls/invoice"

function* invoiceDetail({payload: data}) {
  try {
    const response = yield call(apiGetInvoiceDetail, data)
    yield put(invoiceDetailSuccess(response))
  } catch (error) {
    yield put(invoiceDetailError(error))
  }
}

function* invoiceSelect({payload: data}) {
  try {
    const response = yield call(apiGetInvoiceSelect, data)
    yield put(invoiceSelectSuccess(response))
  } catch (error) {
    yield put(invoiceSelectError(error))
  }
}

function* invoiceUpdate({payload: data}) {
  try {
    const response = yield call(apiPostInvoiceUpdate, data)
    yield put(invoiceUpdateSuccess(response))
  } catch (error) {
    yield put(invoiceUpdateError(error))
  }
}

export function* watchInvoiceDetail() {
  yield takeLatest(INVOICE_DETAIL, invoiceDetail);
}

export function* watchInvoiceSelect() {
  yield takeLatest(INVOICE_SELECT, invoiceSelect);
}

export function* watchInvoiceUpdate() {
  yield takeEvery(INVOICE_UPDATE, invoiceUpdate);
}

function* invoiceSaga() {
  yield all([
    fork(watchInvoiceDetail),
    fork(watchInvoiceSelect),
    fork(watchInvoiceUpdate),
  ]);
}

export default invoiceSaga
